import * as React from 'react';
import { SVGProps } from 'react';
import "./svgs.scss";

const SmartRouting = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    className={`dynamic-icon ${props.className}`}
    viewBox='0 0 32 32'
    {...props}
  >
    <path
      d='M21 6H26V11'
      stroke='#9395A1'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M26 21V26H21'
      stroke='#9395A1'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 6L26 26'
      stroke='#9395A1'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.8284 13.1716L26 6'
      stroke='#9395A1'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 26L13.1716 18.8284'
      stroke='#9395A1'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default SmartRouting;
